<template>
  <b-modal 
    :id="id" 
    :header-class="`align-items-center px-20 py-15 ${variant}`"
    body-class="p-20"
    footer-class="px-20 py-15"
    :hide-footer="hideFooter"
    :no-close-on-esc="noCloseOnEsc"
    :no-close-on-backdrop="noCloseOnBackdrop"
    @show="init()"
    @hidden="clear()"
  >
    <template #modal-header>
      <div class="modal-title">
        <span class="fs-db-28">{{ title }}</span>
      </div>
      <div
        v-if="showClose"
        :id="`close-${id}`"
        type="button"
        class="close-modal"
        aria-label="Close"
        @click.prevent="onClose()"
      >
        <i class="fal fa-times"></i>
      </div>
    </template>

    <template>
      <div class="fs-sa-16" v-if="description">{{ description }}</div>
      <slot name="description" v-if="!description"></slot>
    </template>

    <template #modal-footer>
      <b-button :variant="confirmVariant" @click.prevent="onConfirm(); onClick(confirmValue)" v-if="showConfirm">
        {{ _confirm }}
      </b-button>
      <b-button :variant="cancelVariant" @click.prevent="onCancel(); onClick(cancelValue)" v-if="showCancel">
        {{ _cancel }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    show: {
      default: false,
    },
    variant: {
      type: String,
      default: "default",
    },
    title: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },

    showConfirm: {
      type: Boolean,
      default: true,
    },
    // Confirm
    confirm: {
      type: String,
      default: "OK",
    },
    confirmVariant: {
      type: String,
      default: "blue",
    },
    confirmValue: {
      type: [String,Boolean],
      default: true,
    },

    // Cancel
    showCancel: {
      type: Boolean,
      default: true,
    },
    cancel: {
      type: String,
      default: "Cancel",
    },
    cancelVariant: {
      type: String,
      default: "default",
    },
    cancelValue: {
      type: [String,Boolean],
      default: false,
    },

    // Close
    showClose: {
      type: Boolean,
      default: true,
    },

    // Timer
    timer: {
      type: Number,
      default: 0, // sec
    },

    //footer
    hideFooter: {
      type: Boolean,
      default: false,
    },
    noCloseOnEsc: {
      type: Boolean,
      default: false,
    },
    noCloseOnBackdrop: {
      type: Boolean,
      default: false,
    },
  },  
  data() {
    return {
      root: {
        timer: {
          on: false,
          countdown: 0,
        }
      }
    };
  },
  computed: {
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
    }),
    _confirm() {
      if (this.root.timer.on) {
        return this.confirm.replace("{{TIMER}}", this.root.timer.countdown);
      }
      return this.confirm;
    },
    _cancel() {
      if (this.root.timer.on) {
        return this.cancel.replace("{{TIMER}}", this.root.timer.countdown);
      }
      return this.cancel;
    },
  },
  methods: {
    init() {
      // Timer
      if (this.timer > 0) {
        this.root.timer.on = true;
        this.root.timer.countdown = this.timer;
        this.countdownTimer();
      }
    },
    clear() {
      // Timer
      if (this.root.timer.on) {
        this.root.timer.on = false;
        this.root.timer.countdown = 0;
      }
    },
    countdownTimer() {
      const intv = setInterval(() => {
        if (this.root.timer.on) {
          if (this.root.timer.countdown > 0) {
            this.root.timer.countdown--;
          } else {
            this.onTimeout();
            clearInterval(intv);
          }
        } else {
          clearInterval(intv);
        }
      }, 1000);
    },
    onClick(value) {
      this.$emit("onClick", value);
    },
    onConfirm() {
      this.$emit("onConfirm", this.confirmValue);
    },
    onCancel() {
      this.$emit("onCancel", this.cancelValue);
    },
    onClose() {
      this.$emit("onClose");
    },
    onTimeout() {
      this.$emit("onTimeout");
    },
  },
  watch: {
    show(newValue) {
      if (newValue) {
        this.$bvModal.show(this.id);
      } else {
        this.$bvModal.hide(this.id);
      }
    },
  }
};
</script>